
/* Selectors */
// Main App
import isEmpty from 'lodash/isEmpty';

export const getAuthenticatedState = state => state.app.isAuthenticated;
export const getSessionUserId = state => (!isEmpty(state.app.user) ? state.app.user._id : null);
export const getUserName = state => state.app.user ? state.app.user.username : '';
export const getUser = state => state.app.user;
export const getEditingUserInfoState = state => state.app.isEditingUserInfo;
export const getSavingUserInfoState = state => state.app.isSavingUserInfo;
export const getFooterBelowVisibleState = state => state.app.isFooterBelowVisible;
export const getBackButtonVisibleState = state => state.app.isBackButtonVisible;

// login
export const getPasswordProcessingState = state => state.app.isFetching;
export const getRequestOTPState = state => state.app.isOTPSent;
export const getRequestingOTPState = state => state.app.isRequestingOtp;
export const getOTPVerifyingState = state => state.app.isVerifying;
export const getIsLoginOtpFailure = state => state.app.isLoginOtpFailure;

//register
export const getUserRegisteringState = state => state.app.isRegistering;
export const getRequestOTPRegisterState = state => state.app.isRegisterOTPSent;

//contactuspage
export const getSubmittingState = state => state.app.isSubmitting;

//jobs
export const getJobsFetchingState = state => state.app.isFetchingJobs;
export const getJobsList = state => state.app.jobs;

//homepage
export const getAppCities = state => state.app.cities;
export const getAppOccasions = state => state.app.occasions;
export const getAppGuestRange = state => state.app.guest_range;
export const getAppBudgetRange = state => state.app.budget_range;
export const getAppPackageDetails = state => state.app.package_details;
export const getPageDataState = state => state.app.pagedata;
export const getNationState = state => state.app.nation;

export const getAppRedirectionStatus = state => state.app.isPageRedirect;
export const getAppRedirectUrl = state => state.app.redirectUrl;
export const getAppPageNotFoundState = state => state.app.isPageNotFound;

export const getPopularSearchesFromPageData = state => !isEmpty(state.app.pagedata) && state.app.pagedata.quickSearchLinks ? state.app.pagedata.quickSearchLinks : [];

// corporate enquiry
export const getCorporatePageData = state => state.app.corporatepagedata;
export const getCorporateHeaderVisibilityState = state => state.app.isCorporateHeaderVisible;
export const getCorporateFormSubmitState = state => state.app.isCorporateLeadSubmitting;
export const getCorporateUserRegisterStatus = state => state.app.isCorporateUserRegistered;
export const getAgentCityContacts = state => state.app.agentCityContacts;
export const getDefaultAgentContact = state => state.app.defaultWhatsAppContact;
export const getWhatsappPhoneNo = state => state.app.WHATSAPP_PHONE_NO;
export const getCountryCodeDict = state => state.app.countryCodeDict;

//Network
export const getNetworkStatus = state => state.app.isOnline;

export const getAuthView = state => state.app.authView;

export const getLoginSucessModalState = state => state.app.isLoginSuccessModalVisible;
export const getResendLoginOtpState = state => state.app.isResendingLoginOtp;

// register
export const getRegisterSuccessModal = state => state.app.isRegisterSuccessModalVisible;
export const getWrongOtpEnteredValue = state => state.app.isWrongOtpEntered;

// corporate enquiry
export const getCorporatePageDataState = state => state.app.isFetchingCorporateData;
export const getCallPhoneNo = state => state.app.CALL_PHONE_NO;

export const getOTPError = state => state.app.otpError;
export const getMobileError = state => state.app.mobileError;

// user location
export const getUserLocation = state => state.app.userCurrentCity;
export const getLoginSignUpRedirectionUrl = state => state.app.loginRedirectionUrl; 
export const getAdsBannerShowState = state => state.app.isAdsBannerVisible; 
